import { getAccessToken } from "@lib/shared/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";

export const saveAction = async (
    data: Record<string, unknown>,
): Promise<{ data: string | null; error: Error | null }> => {
    const accessToken = getAccessToken() as string;
    const config: AxiosRequestConfig = {
        method: "post",
        url: `/api/actionLogger`,
        headers: {
            Authorization: `Bearer ${accessToken ?? ""}`,
        },
        data: {
            ...data,
        },
    };
    const { data: savedAction, error } = await apiHandler<{ data: string }>(
        () => HTTP.client(config),
    );

    return {
        data: savedAction?.data ?? null,
        error,
    };
};
